<template>
  <q-badge
    :class="badgeClass"
    :label="text"
    :rounded="rounded"
    :outline="outline"
    :floating="floating"
  />
</template>

<script>
export default {
  name: 'Badge',
  props: {
    variant: {
      type: String,
      default: '',
      validator: val => {
        if (val) {
          return [
            'default',
            'primary',
            'secondary',
            'success',
            'warning',
            'info',
            'danger'
          ].includes(val)
        }
        return true
      }
    },
    text: {
      type: [String, Number],
      default: ''
    },
    rounded: {
      type: Boolean,
      default: true
    },
    outline: {
      type: Boolean,
      default: false
    },
    floating: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const badgeClass = {
      'bg-white text-primary font-semibold': !props.variant,
      'bg-gray text-black': props.variant === 'default',
      'bg-primary': props.variant === 'primary',
      'bg-secondary': props.variant === 'secondary',
      'bg-success': props.variant === 'success',
      'bg-warning': props.variant === 'warning',
      'bg-info': props.variant === 'info',
      'bg-danger': props.variant === 'danger'
    }

    return { badgeClass }
  }
}
</script>
